/* global axios */
import ApiClient from './ApiClient';

class TeamPerformanceAPI extends ApiClient {
  constructor() {
    super('team_performance', { accountScoped: true });
  }

  get(params) {
    return axios.get(this.url, { params });
  }
}

export default new TeamPerformanceAPI();
